import { Component, OnInit, Output, EventEmitter, Input, Injector } from '@angular/core';
import { FileUploader, FileItem } from 'ng2-file-upload';
import { AppConsts } from '../../shared/AppConsts';
import { FileUploaderOptions } from 'ng2-file-upload';
import { AppComponentBase } from '../app-component.base';
import { FileLikeObject } from 'ng2-file-upload';

@Component({
    selector: '[cams-file-upload]',
    template:
        `
        <div type ng2FileDrop class="dropzone-wrapper"
            [ngClass]="{'nv-file-over': hasBaseDropZoneOver}"
            (fileOver)="fileOverBase($event)"
            [uploader]="uploader" (click)="fileInput.click(); emitClickEvent();">
            <ng-content>
            </ng-content>
        </div>
        <input type="file" #fileInput ng2FileSelect [uploader]="uploader" [accept]="allowedFileMimeType.toString()" class="d-none"/>
    `
})
export class CamsFileUploader extends AppComponentBase implements OnInit {
    public baseUrl: string;
    public uploader: FileUploader;
    public hasBaseDropZoneOver = false;
    public hasAnotherDropZoneOver = false;
    @Input() 
    url: string = null;
    @Input() 
    allowedFileMimeType: string;
    @Output() onFileUpload = new EventEmitter();

    @Output() clickEmitter = new EventEmitter();

    constructor(injector: Injector) {
        super(injector);
        this.baseUrl = AppConsts.remoteServiceBaseUrl;
    }

    ngOnInit(): void {
        let maxFileSize = 5 * 1024 * 1024;
        this.uploader = new FileUploader({
            url: `${this.baseUrl}${this.url}`, autoUpload: true,
            authToken: 'Bearer ' + abp.utils.getCookieValue('Abp.AuthToken'),
            headers: [{ name: abp.security.antiForgery.tokenHeaderName, value: abp.security.antiForgery.getToken() }],
            allowedMimeType: [...this.allowedFileMimeType],
            maxFileSize:maxFileSize
        });

        this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: any) => {
            let message = '';
            switch (filter.name) {
              case 'fileSize':
                message = 'Warning ! \nThe uploaded file exceeds the maximum allowed size of ' + this.formatBytes(maxFileSize);
                break;
              default:
                message = this.l("InvalidFileTypeUploaded");
                break;
            }

            this.notify.error(message);
        }

        this.uploader.onBeforeUploadItem = function (fileItem) {
            abp.ui.setBusy();
        }

        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.onFileUpload.emit({ item: item, response: response, status: status, headers: headers });
            abp.ui.clearBusy();
        };
    }

    emitClickEvent() {
        this.clickEmitter.emit(false);
    }

    public fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    public fileOverAnother(e: any): void {
        this.hasAnotherDropZoneOver = e;
    }

    formatBytes(bytes, decimals?) {
        if (bytes == 0) return '0 Bytes';
        const k = 1024,
          dm = decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      }
}
